export function buildEvalModelsPageQueryV1(workspaceId: number, projectId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.EvaluationModels.Queries.EvalModelsPageQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
	}
}
export function buildEvalModelByNameQueryV1(workspaceId: number, projectId: number, evalModelName: string)
{
	return {
		'$type': 'TCh.Domain.Evaluation.EvaluationModels.Queries.EvalModelByNameQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelName': evalModelName
	}
}
export function buildEvalModelByIdQueryV1(workspaceId: number, evalModelId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.EvaluationModels.Queries.EvalModelByIdQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'EvalModelId': evalModelId,
	}
}